<script lang="ts" setup>
import { type PropType, ref, watch } from '#imports';
import { drawGoods } from '~/api/oj/home';
import bg from '~/assets/image/goods-result-modal/bg.png';
import type { DrawGoodsVo } from '~/types/auto/actuator';
import CurrentGallery from './CurrentGallery.vue';
import EnoughGallery from './EnoughGallery.vue';

const model = defineModel('open', { type: Boolean, default: false });
const drawKey = ref(0);
const STEP = {
  CURRENT_GALLERY: 1,
  ENOUGH_GALLERY: 2,
};
const step = ref(STEP.CURRENT_GALLERY);
const props = defineProps({
  isLimit: {
    type: Boolean,
    default: true,
  },
  drawCount: {
    type: Number,
    default: 1,
  },
  result: {
    type: Object as PropType<DrawGoodsVo>,
    default: () => ({}),
  },
  drawSingle: {
    type: Function,
    default: () => {},
  },
  drawMultiple: {
    type: Function,
    default: () => {},
  },
});
const transitionName = ref('fade'); //为了在弹窗展示时让抽奖动画完整播放
const handleDrawSingle = () => {
  step.value = STEP.CURRENT_GALLERY;
  drawKey.value++;
  props.drawSingle();
};
const handleDrawMultiple = () => {
  step.value = STEP.CURRENT_GALLERY;
  drawKey.value++;
  props.drawMultiple();
};
const goToEnoughStep = () => {
  step.value = STEP.ENOUGH_GALLERY;
};
const handleClose = () => {
  model.value = false;
};
const afterClose = () => {
  transitionName.value = 'fade'; //为了下次在弹窗展示时让抽奖动画完整播放
};
watch(
  () => model.value,
  (newVal) => {
    if (newVal) {
      step.value = STEP.CURRENT_GALLERY;
    } else {
      transitionName.value = undefined; //为了在弹窗消失时缩放过渡消失
    }
  },
);
</script>
<template>
  <a-modal
    v-model:open="model"
    closable
    :centered="true"
    width="100%"
    :footer="null"
    :mask-closable="false"
    :destroy-on-close="true"
    wrap-class-name="goods-result-modal"
    :transition-name="transitionName"
    :mask-style="{
      backgroundColor: 'rgba(0, 0, 0, 0.9)',
      backgroundImage: `url(${bg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'repeat-x',
    }"
    :after-close="afterClose"
  >
    <div class="relative">
      <Transition
        name="fade"
        :duration="{
          enter:0,
          leave: 500,
        }"
      >
        <CurrentGallery
          v-show="step === STEP.CURRENT_GALLERY"
          :key="drawKey"
          :draw-count="drawCount"
          :goods-list="result.goodsVOList"
          :draw-single="handleDrawSingle"
          :draw-multiple="handleDrawMultiple"
          :go-to-enough-step="goToEnoughStep"
          :goods-count="result.goodsCount"
          :goods-total="result.goodsTotal"
          :total-count="result.totalCount"
          :is-enough="result.allGoodsList?.length > 0"
          :handle-close="handleClose"
          :title="result.title"
          :is-limit="isLimit"
        />
      </Transition>
      <Transition name="fade">
        <EnoughGallery
          v-show="step === STEP.ENOUGH_GALLERY"
          :title="result.title"
          :sub-title="result.subTitle"
          :handle-close="handleClose"
          :goods-list="result.allGoodsList"
          :goods-count="result.goodsCount"
          :goods-total="result.goodsTotal"
          :total-count="result.totalCount"
          :is-limit="isLimit"
        />
      </Transition>
    </div>
  </a-modal>
</template>
<style>
.goods-result-modal .ant-modal-content {
  @apply !bg-transparent !shadow-none;
}
</style>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style>
